import type {DesignerStores} from '@packages/systems/designer/flux';
import {selectDesignerAbility} from '@packages/systems/designer-abilities';

export const selectCanAccessFormConnectionsAndNotifications: (
  state: DesignerStores
) => boolean = selectDesignerAbility(
  'canAccessFormConnectionsAndNotifications'
);

export const getAllForms = (state: DesignerStores) => {
  return state.DesignerStore.logicComponentForms;
};
